import { MessageSender } from 'web-message-helper';
import { ChangeThemeColorCommand } from 'kaistore-post-messenger/src/commands';

class UserInterfaceHelper {
  constructor() {
    this.lastAppsviewIndex = {
      tabOrder: null,
      appOrder: null
    };
    this.appsviewMounted = false;
  }

  startListeners() {
    window.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      window.close();
      return;
    }
  };
}

export default (UserInterfaceHelper = new UserInterfaceHelper());

export const isOverflown = element => {
  if (!element) {
    return false;
  }
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
};

export const hideFakeSSR = () => {
  const fakeSSR = document.getElementById('ssr');
  fakeSSR.classList.add('hidden');
};

export const setThemeColor = isViewingSetting => {
  const detail = {
    content: isViewingSetting ? 'rgb(50, 3, 116)' : 'rgb(255, 255, 255)'
  };
  MessageSender.send(new ChangeThemeColorCommand({ detail: detail }));
};



/** WEBPACK FOOTER **
 ** ./src/helper/user-interface-helper.js
 **/